import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'LeftAndRightArrows',
  emits: ['left', 'right'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('left'))),
      icon: "",
      color: "transparent",
      elevation: "0",
      class: "chevron-size"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              width: "18",
              height: "18",
              viewBox: "0 0 18 18",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M8.46286 9.21484L11.7212 12.4732L10.7295 13.4648L6.47952 9.21484L10.7295 4.96484L11.7212 5.95651L8.46286 9.21484Z",
                fill: "#7F898E"
              })
            ], -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_btn, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('right'))),
      icon: "",
      color: "transparent",
      elevation: "0",
      class: "chevron-size"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              width: "18",
              height: "18",
              viewBox: "0 0 18 18",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M9.3129 9.21484L6.05457 5.95651L7.04623 4.96484L11.2962 9.21484L7.04623 13.4648L6.05457 12.4732L9.3129 9.21484Z",
                fill: "#7F898E"
              })
            ], -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})